// import { defineNuxtPlugin } from '#app'
// import posthog from 'posthog-js'
export default defineNuxtPlugin(nuxtApp => {

  return
  
  const runtimeConfig = useRuntimeConfig();

  const posthogStatus = runtimeConfig.public.posthogStatus === 'true';
  if(!posthogStatus){
    
    return
  }

  console.log('posthog initializing', runtimeConfig.public.posthogStatus, typeof runtimeConfig.public.posthogStatus, runtimeConfig.public.posthogStatus !== 'true' )

  // posthog.debug(false) 
  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
    api_host: runtimeConfig.public.posthogHost,
    defaults: '2025-05-24',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    capture_pageview: false, // we add manual pageview capturing below,
    
    loaded: (posthog) => {
      console.log('posthog loaded')
        //  posthog.debug(false);
      // if (import.meta.env.MODE === 'development') posthog.debug(false);
    }
  })

  // Make sure that pageviews are captured with each route change
  const router = useRouter();
  router.afterEach((to) => {
    nextTick(() => {
      posthog.capture('$pageview', {
        current_url: to.fullPath
      });
    });
  });

  return {
    provide: {
      posthog: () => posthogClient
    }
  }
})